export const ACCEPTED_FILE_TYPE = "application/pdf"
export const ACCEPTED_FILE_TYPE_EXTENSION = ".pdf"
export const MAX_SIZE = 32 * 1000000 //32MB
